import { Component, Input, OnInit } from '@angular/core';
import { ShippingRateService } from 'src/app/services/shipping-rate.service';

@Component({
  selector: 'calsoft-track',
  templateUrl: './track.component.html',
  styleUrls: ['./track.component.scss']
})
export class TrackComponent implements OnInit {
  @Input() trackNumber: any;
  @Input() trackValue: any
  @Input() carrierCode: any
  status: any = [];
  shippingStatus:any=null;
  shipRocketTracking: any;
  visible: boolean=false;
  trackingUrl: any;
  updates: any;
  constructor(
    private shippingRateService: ShippingRateService
  ) { }

  ngOnInit(): void {
    this.getShipingStatus()

  }

  errorEnabled: boolean=false;
  errorMessage: any;
  getShipingStatus() {

    if (this.carrierCode == "aromex") {
      let values = this.trackValue;

      this.trackValue['Shipments'][0] = this.trackNumber;
      this.shippingRateService.getShippingStatus(this.trackValue).subscribe(
        res => {
          this.status = res['datalist'][0]
          this.visible=true;

        }
      )
    } else if (this.carrierCode == "shipRocket")  {

      this.shippingRateService.getShipRocketShippingStatus(this.trackNumber).subscribe(
        res => {
          this.visible=true;
          this.shipRocketTracking = JSON.parse(res['data']);
          if(this.shipRocketTracking.tracking_data.track_status==1){
            this.shippingStatus = this.shipRocketTracking.tracking_data['shipment_track'][0]['current_status'];
            this.trackingUrl= this.shipRocketTracking.tracking_data['track_url'],
            this.updates=this.shipRocketTracking.tracking_data['shipment_track_activities']
          }else{

            this.errorEnabled=true;     
            this.errorMessage=this.shipRocketTracking.tracking_data.error;
          
          }
        }
      )

    }




  }


  trackUrl() {
    let url = this.trackingUrl;
    window.open(url, '_blank');
  }
}
